import { EcommerceProductOptionModel } from '@/helpers/entities/models/EcommerceProductOptionModel';
export class EcommerceProductSectionModel {
    constructor(payload) {
        const params = payload;
        Object.assign(this, params);
        const initProductOption = (po) => {
            return new EcommerceProductOptionModel(po.node);
        };
        this.productOptions = payload.productOptions.edges.map(initProductOption);
    }
}
